export enum BookingStatus {
  Confirmed = 'Confirmed',
  Unconfirmed = 'Unconfirmed',
  Cancelled = 'Cancelled',
}
